/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const referralsPostRequestSchema = z.object({
  company: z.string(),
  referral: z.string(),
});
